import * as Yup from 'yup';

export const getDockShape = () => ({
  name: Yup.string().required('Informe o nome da doca'),
  startTime: Yup.string().required('Informe a hora de início'),
  endTime: Yup.string().required('Informe a hora de término'),
  loadEnabled: Yup.mixed().transform((value) => value === '1'),
  unloadEnabled: Yup.mixed().transform((value) => value === '1'),
});
